module.exports = __webpack_public_path__ + "static/media/Deck Jacuzzi.278450c4.svg";